import { useSession } from 'next-auth/react';
import { Divider, Flex, Text } from '@eqi-investimentos/react';
import { useT } from '@/libs/i18n/utils/useT';
import { Drawer } from '@/components/modules/Drawer';
import { PERSONAL_INFO_DRAWER_ID } from './utils';
import {
  CONFIRM_DELETE_ACCOUNT_ID,
  ConfirmDeleteAccountDrawer,
} from './ConfirmDeleteAccountDrawer';
import { EditPasswordButton } from './Edit/PasswordButton';
import { EditPasswordDrawer } from './Edit/PasswordDrawer';
import { EditProfileInfoDrawer } from './Edit/ProfileInfoDrawer';
import { EditProfileInfoInput } from './Edit/ProfileInfoInput';
import { ProfileItem } from './Item';

export const PersonalInfoDrawer = () => {
  const t = useT();
  const { data: session } = useSession();

  if (!session || !session.user) return;

  return (
    <>
      <Drawer
        id={PERSONAL_INFO_DRAWER_ID}
        headerContent={
          <Text size="2xl" color="content.primary">
            {t('drawers.personalInfo.header')}
          </Text>
        }
        closeButtonProps={{ top: '3.125rem' }}
        headerProps={{
          pl: '3.4375rem',
          pr: '3rem',
          py: '2.8125rem',
        }}
        bodyProps={{ px: '2xl' }}
      >
        <Flex flexDir="column" justifyContent="space-between" h="full" pb="3xl">
          <Flex flexDir="column" gap="xl">
            <EditProfileInfoInput value={session.user.name ?? ''} type="name" />
            <EditProfileInfoInput
              value={session.user.email ?? ''}
              type="email"
            />
            <EditProfileInfoInput
              value={session.user.phone ?? ''}
              type="phone"
            />
            <EditPasswordButton />
            <Divider borderColor="border.secondary" />
          </Flex>
          <ProfileItem
            title={t('drawers.profile.ctaDeleteAccount')}
            leftIcon="PersonOff"
            type="action"
            onClick={() =>
              window.dispatchEvent(
                new CustomEvent(
                  `open-chakra-modal-${CONFIRM_DELETE_ACCOUNT_ID}`
                )
              )
            }
            showArrow={false}
            py="0"
          />
        </Flex>
        <ConfirmDeleteAccountDrawer />
      </Drawer>
      <EditProfileInfoDrawer
        currentValue={session.user.name ?? ''}
        type="name"
      />
      <EditProfileInfoDrawer
        currentValue={session.user.email ?? ''}
        type="email"
      />
      <EditProfileInfoDrawer
        currentValue={session.user.phone ?? ''}
        type="phone"
      />
      <EditPasswordDrawer />
    </>
  );
};
